"use strict";

// Module API

function checkMaxLength(constraint, value) {
  if (value === null) {
    return true;
  }
  if (value.length <= constraint) {
    return true;
  }
  return false;
}

module.exports = {
  checkMaxLength: checkMaxLength
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/constraints/maxLength.js
// module id = 324
// module chunks = 0